/**
 * @shelf-version: 1.0.1
 */

import Events from './events'

export default Events
